import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, authToken } from "../api/client";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function loadMe() {
      if (!authToken.get()) { setLoading(false); return; }
      try {
        const data = await api('/auth/me');
        if (active) setUser(data.user);
      } catch {
        authToken.set(null);
      } finally {
        if (active) setLoading(false);
      }
    }
    loadMe();
    return () => { active = false; };
  }, []);

  const register = async (payload) => {
    return await api('/auth/register', { method: 'POST', body: JSON.stringify(payload) });
  };

  const login = async (payload) => {
    const data = await api('/auth/login', { method: 'POST', body: JSON.stringify(payload) });
    authToken.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const adminLogin = async (payload) => {
    const data = await api('/admin/auth/login', { method: 'POST', body: JSON.stringify(payload) });
    authToken.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { authToken.set(null); setUser(null); window.location.href = '/'; };

  const value = useMemo(() => ({
    user, loading, register, login, adminLogin, logout,
    isAdmin: user?.accountType === 'admin',
    isCorporate: user?.accountType === 'corporate',
    isIndividual: user?.accountType === 'individual'
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() { return useContext(AuthContext); }
